import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MdWorkOutline, MdFolderSpecial } from "react-icons/md";

import ProjectManagementTable from "./components/ProjectManagementTable";
import api from "../../../services/axios";
import SkeletonTable from "../../../components/skeleton/table";

const BILLING_TYPE_LABELS: Record<number, string> = {
  1: "Fixed Price",
  2: "Hourly Rate",
  3: "Recurring",
};

const formatDate = (iso: string) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR");
};

const ProjectManagement = () => {
  const [projectData, setProjectData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const openProjectId = (location.state as any)?.openProjectId ?? null;

  const columns = [
    { key: "projectName", header: "Projeto" },
    { key: "clientName", header: "Cliente" },
    { key: "startDateDisplay", header: "Início" },
    { key: "estimatedEndDateDisplay", header: "Término Previsto" },
    { key: "billingTypeDisplay", header: "Faturamento" },
  ];

  const transformData = (data: any[]) =>
    data.map((project) => ({
      ...project,
      clientName: project.clientName ?? "—",
      startDateDisplay: formatDate(project.startDate),
      estimatedEndDateDisplay: formatDate(project.estimatedEndDate),
      billingTypeDisplay: BILLING_TYPE_LABELS[project.billingType] ?? "—",
    }));

  useEffect(() => {
    setLoading(true);
    api
      .get("/Project/Projects")
      .then((response) => {
        setProjectData(transformData(response.data));
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(true);
      });
  }, []);

  return (
    <div className="mt-5 animate-fade-up">
      {/* Page header */}
      <div className="mb-5 flex items-center gap-4">
        <div className="dv-aura flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow">
          <MdWorkOutline className="h-6 w-6" aria-hidden="true" />
        </div>
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
            <MdFolderSpecial className="h-3.5 w-3.5" aria-hidden="true" />
            Portal DataValue
          </span>
          <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
            Gestão de projetos
          </h1>
        </div>
      </div>

      {loading ? (
        <SkeletonTable active={loading} />
      ) : (
        <ProjectManagementTable
          columns={columns}
          data={projectData}
          initialOpenProjectId={openProjectId}
        />
      )}
    </div>
  );
};

export default ProjectManagement;
